<template>
  <div class="pa-item-icon">
    <template v-if="itemIconType === 'picture'">
      <img v-bind:src="itemIconValue" />
    </template>
    <template v-else>
      <span>{{itemIconValue}}</span>
    </template>
  </div>
</template>

<script>
// import {GetItem} from '@/graphql/queries/Item.graphql'

export default {
  props : {
    item : {
      default: null
    },

    // itemSlug : {
    //   default: null
    // }
  },

  data(){
    return {
      itemIconType  : 'string',
      itemIconValue : '遮',
    };
  },

  // apollo : {
  //   item : {
  //     query: GetItem,
  //     variables(){
  //       return {
  //         slug: itemSlug
  //       }
  //     }
  //   }
  // }

  watch : {
    item : {
      handler(data){
        if(typeof data === 'undefined') return;
        
        if( this.checkImageIconExists() ){
          this.itemIconType  = 'picture';
          this.itemIconValue = '';
        }else{
          this.itemIconType  = 'string';
          this.itemIconValue = data.name[0];
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods : {
    checkImageIconExists(){
      return false;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-item-icon{
  width:100%;
  height:100%;
  border-radius: 50%;
  margin:0 auto;

  text-align: center;
  line-height: 100%;
  font-size:1.5rem;
  user-select: none;

  img{
    border-radius: 50%;
  }

  // @media screen and (min-width: $desktop) {
  //   width:75px;
  //   height:75px;
  //   line-height: 75px;
  //   font-size:2rem;
  // }
}
</style>